import { useEffect, useState } from "react"
import { LocationIcon } from "../../icons/locationIcon"
import { PhoneIcon } from "../../icons/phoneIcon"
import { Button } from "../ui/Button"
import { CalendarBlank } from "../../icons/calendarBlank"
import clsx from "clsx"
import { TimeIcon } from "../../icons/timeIcon"
import { Calendar } from "../ui/Calendar"
import { TimeSlotSection } from "./TimeSlotSection"
import { Dialog, DialogContent, DialogTrigger } from "../ui/Modal"

export const ServiceSlots = ({ setFormStep, handleTimeSlotSubmit, timeSlots}) => {
    const [selected, setSelected] = useState('date');
    const [calendarValue, setCalendarValue] = useState();
    const [timeValue, setTimeValue] = useState()
    const [currentSlots, setCurrentSlots] = useState([]);
    const [mobileCalendar, setMobileCalendar] = useState(false);
    const [mobileTime, setMobileTime] = useState(false);


    const currentDate = new Date();

    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + 36);

    useEffect(() => {
        if (calendarValue) {
            const dummyDate = new Date(calendarValue)
            const year = dummyDate.getFullYear();
            const month = (dummyDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
            const day = dummyDate.getDate().toString().padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;
            // const calendarValueString = calendarValue.toISOString().split('T')[0];
            setCurrentSlots(timeSlots.data[formattedDate])
        }
        setTimeValue();
    }, [calendarValue])

    

    const isDisabled = (day, time) => {
        if (timeSlots.data === false || !timeSlots.data[day]) {
          // The entire day is disabled if it's not in the non-disabled list
          return true;
        }
      };

    const getDisabledDays = () => {
        const disabledDays = [];
      
        // Loop through each day in the range
        // let currentDate = new Date(startDate);
        while (currentDate <= futureDate) {
          const currentDay = currentDate.toISOString().split('T')[0];
            const currentTime = currentDate.toISOString();
            
          // Check if the day is disabled
            if (isDisabled(currentDay, currentTime)) {
                const dateComponents = currentDay.split('-');
                disabledDays.push( new Date(
                    parseInt(dateComponents[0]),   // Year
                    parseInt(dateComponents[1]) - 1, // Month (subtract 1 because months are zero-based)
                    parseInt(dateComponents[2])      // Day
                ));
            }
      
          // Move to the next day
          currentDate.setDate(currentDate.getDate() + 1);
        }

        return disabledDays;
    };
    const disabledDays = getDisabledDays();

    return (
        <div className="flex flex-col gap-4 relative">
            <div className="max-lg:w-full max-lg:my-5 order-last lg:absolute flex max-lg:flex-col-reverse gap-4 lg:gap-10 lg:-top-[60px] lg:right-0">
                <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={()=> {setFormStep(0)}}>Ακύρωση</Button>
                <Button disabled={calendarValue === undefined || timeValue === undefined } className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'} onClick={() => { handleTimeSlotSubmit(timeValue) }}>Επόμενο</Button>
            </div>
            <div className="flex flex-col max-lg:gap-4">
                <div className="p-6 flex bg-white max-lg:rounded-[12px] rounded-t-[12px] border-b border-[#E2E2E2] w-full lg:justify-between">
                    <h4 className="max-lg:hidden">{timeSlots.markerInfo.name}</h4>
                    <div>
                        <h4 className="lg:hidden pb-3">Τοποθεσία</h4>
                        <p className="lg:hidden text-label pb-3">{timeSlots.markerInfo.name}</p>
                        <div className="flex gap-1 items-center">
                            <LocationIcon />
                            <p className="text-body text-[#282828]">{timeSlots.markerInfo.address}</p>
                        </div>
                        <div className="flex gap-1 items-center">
                            <PhoneIcon />
                            <p className="text-body text-[#282828]">{timeSlots.markerInfo.phone}</p>
                        </div>
                    </div>
                </div>
                {!timeSlots.data && <p className="py-2 text-center lg:hidden">Δεν υπάρχουν διαθέσιμα ραντεβού στον συγκεκριμένο σταθμό, επίλεξε ένα άλλο σημείο.</p>}
                <div className="bg-white p-4 rounded-[12px] lg:hidden text-[#6A6A6A] flex flex-col gap-2" style={{
                    boxShadow: '0px 2px 6px 6px #63636333'
                }}>
                    <h5>Επιλογή ημερ/νίας</h5>
                    <div className="w-full h-[1px] bg-[#E2E2E2]"/>
                    <div className="flex w-full justify-between">
                        {calendarValue ? calendarValue.toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            }).replace(/\//g, '/') : '-- / -- / ----'
                        }
                        <Dialog open={mobileCalendar} onOpenChange={(open) => { if (!open) { setCalendarValue(undefined); } setMobileCalendar(open); }}>
                            <DialogTrigger>
                                <CalendarBlank className={'rounded-full stroke-white p-1 h-8 w-8 bg-[#D4002A]'}/>
                                </DialogTrigger>
                                <DialogContent className=" max-lg:p-6 max-lg:gap-0 max-lg:pt-3 max-lg:pb-10 max-lg:h-[100vh]">
                                <h2>Επιλογή ημερ/νίας</h2>
                                <div className="flex flex-col h-full pt-16 justify-between">
                                <Calendar
                                    mode="single"
                                    fromDate={new Date()}
                                    toDate={futureDate}
                                    selected={calendarValue}
                                    onSelect={setCalendarValue}
                                    disabled={disabledDays}
                                    />
                                <div className="w-full my-5 flex flex-col-reverse gap-4">
                                    <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={() => { setMobileCalendar(false); setCalendarValue(undefined)}}>Ακύρωση</Button>
                                    <Button disabled={calendarValue === undefined} className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'} onClick={()=> {setMobileCalendar(false)}}>Επόμενο</Button>
                                    </div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </div>    
                </div>
                <div className="bg-white p-4 rounded-[12px] lg:hidden text-[#6A6A6A] flex flex-col gap-2" style={{
                    boxShadow: '0px 2px 6px 6px #63636333'
                }}>
                    <h5>Επιλογή ώρας</h5>
                    <div className="w-full h-[1px] bg-[#E2E2E2]"/>
                    <div className="flex w-full justify-between items-center">
                        <h6>{timeValue ? new Date(timeValue).toLocaleTimeString('el-GR',{
            timeZone: 'Europe/Athens',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Use 24-hour format
            hourCycle: 'h23' // Force 2-digit hours
          }) : '00 : 00'}</h6>
                        <Dialog open={mobileTime} onOpenChange={(open) => { if (!open) { setTimeValue(undefined); } setMobileTime(open); }}>
                            <DialogTrigger disabled={!calendarValue} className="disabled:opacity-70">
                                <TimeIcon className={'rounded-full stroke-white p-1 h-8 w-8 bg-[#D4002A]'}/>
                            </DialogTrigger>
                            <DialogContent className=" max-lg:p-6 max-lg:gap-0 max-lg:pt-3 max-lg:pb-10 max-lg:h-[100vh]">
                                <h2>Επιλογή ώρας</h2>
                                <div className="h-full flex flex-col justify-between">
                                    <div className="pt-16">
                                        <TimeSlotSection setTimeValue={setTimeValue} timeValue={timeValue} currentSlots={currentSlots} />
                                        </div>
                                <div className="w-full my-5 flex flex-col-reverse gap-4">
                                    <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={() => { setMobileTime(false); setTimeValue(undefined)}}>Ακύρωση</Button>
                                    <Button disabled={timeValue === undefined} className={'disabled:bg-[#A5A5A5] rounded-[6px] bg-[#D4002A] py-3 px-10 text-primary-button text-white'} onClick={()=> {setMobileTime(false)}}>Επόμενο</Button>
                                    </div>
                                    </div>
                            </DialogContent>
                        </Dialog>
                    </div>
                </div>
                <div className="max-lg:hidden p-6 gap-4 flex bg-white rounded-b-[12px] border-[#E2E2E2] w-full justify-between">
                    <Button onClick={()=> setSelected('date')} className={clsx('py-3 px-16 rounded-full border border-[#A5A5A5] flex gap-3 items-center', selected === 'date' && 'bg-black')}>
                        <CalendarBlank className={clsx('h-6 w-6', selected === 'date' ? 'stroke-white' : 'stroke-black')} />
                        <div className="flex w-full justify-between">
                            <h6 className={selected === 'date' ? 'text-white' : ''}>
                                {calendarValue ?calendarValue.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }).replace(/\//g, '/') : 'Επιλογή ημερ/νίας'
                                }
                            </h6>
                        </div>
                    </Button>
                    <Button onClick={()=> setSelected('time')} disabled={!calendarValue} className={clsx('py-3 px-16 rounded-full border border-[#A5A5A5] flex gap-3 items-center', selected === 'time' && 'bg-black')}>
                        <TimeIcon className={clsx('h-6 w-6',selected === 'time' ? 'stroke-white' : 'stroke-black')}/>
                        <h6 className={selected === 'time' &&  'text-white' }>{timeValue ?new Date(timeValue).toLocaleTimeString('el-GR',{
            timeZone: 'Europe/Athens',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Use 24-hour format
            hourCycle: 'h23' // Force 2-digit hours
          }) : 'Επιλογή ώρας'
                            }</h6>
                    </Button>
                </div>
            </div>
            <div className="max-lg:hidden">
            {!timeSlots.data && <p className="py-5 text-center">Δεν υπάρχουν διαθέσιμα ραντεβού στον συγκεκριμένο σταθμό, επίλεξε ένα άλλο σημείο.</p>}
            {selected === 'date' ? 
                <Calendar
                    mode="single"
                    fromDate={new Date()}
                    toDate={futureDate}
                    selected={calendarValue}
                    onSelect={setCalendarValue}
                    disabled={disabledDays}
                />
                    : <TimeSlotSection setTimeValue={setTimeValue} timeValue={timeValue} currentSlots={currentSlots} />}
            </div>
        </div>
    )
}